document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname !== '/') return;

  document.querySelectorAll('[data-testid="product-list"]').forEach((section) => {
    const grid = section.querySelector('.resource-list');
    if (!grid) return;

    const products = Array.from(
      grid.querySelectorAll('.resource-list__item')
    );

    for (let i = products.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [products[i], products[j]] = [products[j], products[i]];
    }

    products.forEach((product) => grid.appendChild(product));
  });
});